import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default function initEmployeeTestimonialsSlider(selector = '.ks-employee-testimonials__swiper') {
  const sliders = document.querySelectorAll(selector);

  sliders.forEach((el) => {
    const root = el.closest('.ks-employee-testimonials__slider') || el.parentElement;
    const nextEl = root ? root.querySelector('.ks-employee-testimonials__nav-next') : null;
    const prevEl = root ? root.querySelector('.ks-employee-testimonials__nav-prev') : null;
    const scope = root ? root.parentElement : null;
    const currentEl = scope ? scope.querySelector('.ks-employee-testimonials__counter-current') : null;

    const pad = (n) => String(n).padStart(2, '0');

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: { nextEl, prevEl },
      on: {
        slideChange(swiper) {
          if (currentEl) {
            currentEl.textContent = pad(swiper.realIndex + 1);
          }
        },
      },
    });
  });
}
